import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import NewsList from "./components/NewsList";
import FeaturedMovies from "./components/FeaturedMovies";
import SpecialEntry from "./components/SpecialEntry";
import RankingList from "./components/RankingList";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pb-4">
        <HeroCarousel />

        <div className="px-4 py-8 md:px-8 md:py-10">
          <CategoryQuickLinks />

          <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_320px]">
            <div className="min-w-0 space-y-10">
              <section>
                <SectionHeading
                  title="精选影视推荐"
                  icon="ri-star-line"
                  moreLabel="查看更多"
                  moreLink="/category/movie"
                />
                <FeaturedMovies />
              </section>

              <section>
                <SectionHeading
                  title="最新影视资讯"
                  icon="ri-newspaper-line"
                  moreLabel="浏览专题"
                  moreLink="/special"
                />
                <NewsList />
              </section>
            </div>

            <aside className="min-w-0 space-y-8">
              <section className="rounded-lg border border-background-200 bg-background-50 p-5">
                <SectionHeading title="热门专题" icon="ri-bookmark-3-line" />
                <SpecialEntry />
              </section>

              <section className="rounded-lg border border-background-200 bg-background-50 p-5">
                <SectionHeading title="口碑排行榜" icon="ri-trophy-line" />
                <RankingList />
              </section>
            </aside>
          </div>

          <SiteIntro />
        </div>
      </main>
      <Footer />
    </div>
  );
}